import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import { userLogout, forbiddenAccess } from './auth';
import utils from '../lib/utils';

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getBusinessInfoStart() {
  return {
    type: types.GET_BUSINESS_START,
  };
}

export function getBusinessInfoSuccess({ business }) {
  return {
    type: types.GET_BUSINESS_SUCCESS,
    business,
  };
}

export function getBusinessIdSuccess({ businessId }) {
  return {
    type: types.GET_BUSINESS_ID_SUCCESS,
    businessId,
  };
}

export function getBusinessInfoFail() {
  return {
    type: types.GET_BUSINESS_FAIL,
  };
}

export function getBusinessStatusStart() {
  return {
    type: types.GET_BUSINESS_STATUS_START,
  };
}

export function getBusinessStatusSuccess({ status }) {
  return {
    type: types.GET_BUSINESS_STATUS_SUCCESS,
    status,
  };
}

export function getBusinessStatusFail() {
  return {
    type: types.GET_BUSINESS_STATUS_FAIL,
  };
}

export function getPhoneListSuccess({ phoneList }) {
  return {
    type: types.GET_PHONE_LIST_SUCCESS,
    phoneList,
  };
}

export function getPhoneListFail() {
  return {
    type: types.GET_PHONE_LIST_FAIL,
  };
}

export function addPhoneNumberStart() {
  return {
    type: types.ADD_PHONE_NUMBER_START,
  };
}

export function addPhoneNumberSuccess({ phoneNumber, status }) {
  return {
    type: types.ADD_PHONE_NUMBER_SUCCESS,
    phoneNumber,
    status,
  };
}

export function addPhoneNumberFail() {
  return {
    type: types.ADD_PHONE_NUMBER_FAIL,
  };
}

export function removePhoneNumberStart() {
  return {
    type: types.REMOVE_PHONE_NUMBER_START,
  };
}
export function removePhoneNumberSuccess({ phoneNumber }) {
  return {
    type: types.REMOVE_PHONE_NUMBER_SUCCESS,
    phoneNumber,
  };
}
export function removePhoneNumberFail() {
  return {
    type: types.REMOVE_PHONE_NUMBER_FAIL,
  };
}

export function sendNotificationStart() {
  return {
    type: types.SEND_NOTIFICATION_START,
  };
}
export function sendNotificationSuccess() {
  return {
    type: types.SEND_NOTIFICATION_SUCCESS,
  };
}
export function sendNotificationFail() {
  return {
    type: types.SEND_NOTIFICATION_FAIL,
  };
}

export function getBusiness() {
  return (dispatch, getState) => {
    dispatch(getBusinessInfoStart());

    const { auth } = getState();
    const reqBusiness = Object.assign(
      {},
      {
        query: auth.userid,
      },
    );

    request
      .get(`${window.Config.API_URL}/business/studioId`)

      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getBusinessIdSuccess({ businessId: resp.body }));
      })
      .catch((ex) => {
        console.log('Failed to fetch studio id');
      });
    return request
      .get(`${window.Config.API_URL}/business/info`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getBusinessInfoSuccess({ business: resp.body }));
      })
      .catch((ex) => {
        dispatch(getBusinessInfoFail());
        dispatch(userLogout());
      });
  };
}

export function getBusinessStatus() {
  return (dispatch) => {
    dispatch(getBusinessStatusStart());
    return request
      .get(`${window.Config.API_URL}/business/info/status`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getBusinessStatusSuccess({ status: resp.body }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getBusinessStatusFail());
      });
  };
}

export function getPhoneList() {
  return (dispatch) => {
    request
      .get(`${window.Config.API_URL}/business/info/phoneList`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getPhoneListSuccess({ phoneList: resp.body }));
        } else {
          dispatch(getPhoneListFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getPhoneListFail());
      });
  };
}

export function addPhoneNumber({ phoneNumber }) {
  return (dispatch, getState) => {
    dispatch(addPhoneNumberStart());

    const { auth } = getState();
    const params = Object.assign(
      {},
      {
        id: auth.userid,
        phone: phoneNumber,
      },
    );

    request
      .post(`${window.Config.API_URL}/business/info/addVerifyNum`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(
            addPhoneNumberSuccess({
              phoneNumber,
              status: !resp.body.message,
            }),
          );
        } else {
          dispatch(addPhoneNumberFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(addPhoneNumberFail());
      });
  };
}

export function removePhoneNumber({ phoneNumber }) {
  return (dispatch, getState) => {
    dispatch(removePhoneNumberStart());

    const { auth } = getState();
    const params = Object.assign(
      {},
      {
        id: auth.userid,
        phone: phoneNumber,
      },
    );

    request
      .post(`${window.Config.API_URL}/business/info/removeNum`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(removePhoneNumberSuccess({ phoneNumber }));
        } else {
          dispatch(removePhoneNumberFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(removePhoneNumberFail());
      });
  };
}

export function sendNotification(data) {
  return (dispatch, getState) => {
    dispatch(sendNotificationStart());

    const { auth } = getState();
    const params = Object.assign({}, data, {
      id: auth.userid,
    });

    request
      .post(`${window.Config.API_URL}/business/notify`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(sendNotificationSuccess());
        } else {
          dispatch(sendNotificationFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(sendNotificationFail());
      });
  };
}

const getBusinessDetailsStart = () => {
  return {
    type: types.GET_BUSINESS_DETAILS_START,
  };
};
const getBusinessDetailsSuccess = (data) => {
  return {
    type: types.GET_BUSINESS_DETAILS_SUCCESS,
    data,
  };
};

const getBusinessDetailsFail = () => {
  return {
    type: types.GET_BUSINESS_DETAILS_FAIL,
  };
};

export function getBusinessDetails(businessId) {
  return (dispatch) => {
    dispatch(getBusinessDetailsStart());
    request
      .get(`${window.Config.API_URL}/livedashboard/business`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(getBusinessDetailsSuccess(data));
        } else {
          dispatch(getBusinessDetailsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getBusinessDetailsFail());
      });
  };
}

const getLocationDetailsSuccess = (data, typeofaccess) => {
  return {
    type: types.GET_BUSINESS_LOCATIONS_SUCCESS,
    data,
    typeofaccess,
  };
};

const getLocationDetailsFail = () => {
  return {
    type: types.GET_BUSINESS_LOCATIONS_FAIL,
  };
};

export function getLocationDetails(typeofaccess) {
  return (dispatch) => {
    request
      .get(
        `${window.Config.API_URL}/livedashboard/business/locations?grant=${typeofaccess}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(getLocationDetailsSuccess(data, typeofaccess));
          console.log('Data', data);
        } else {
          dispatch(getLocationDetailsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getLocationDetailsFail());
      });
  };
}

export function setSelectedLocation(location) {
  return {
    type: types.SET_SELECTED_LOCATION,
    location,
  };
}

/* ========= updateBusinessName API ========= */

const updateBusinessNameStart = () => ({
  type: types.UPDATE_BUSINESS_NAME_START,
});

const updateBusinessNameSuccess = (studioName) => ({
  type: types.UPDATE_BUSINESS_NAME_SUCCESS,
  studioName,
});

const updateBusinessNameFail = () => ({
  type: types.UPDATE_BUSINESS_NAME_FAIL,
});

export function updateBusinessName(params) {
  return (dispatch) => {
    dispatch(updateBusinessNameStart());
    request
      .post(`${window.Config.API_URL}/business/settings/sw-info`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = resp.body;
          console.log('Response------------------->', data);
          dispatch(updateBusinessNameSuccess(data.studioName));
          utils.setCookie('studio_name', data.studioName);
        } else {
          dispatch(updateBusinessNameFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(updateBusinessNameFail());
      });
  };
}
